import CacheMan from "../jslibs/CacheMan";
import {FMFile} from "../shared/FMFile";
import Dirs from "./Dirs";
import FManApi, { TConfligResolution } from "./FManApi";
import Usernames from "./Usernames";

export default class Files extends CacheMan<string, FMFile> {
    static _i:Files
    static get i(){
        if (!this._i) this._i = (window as any).files = new Files("files", 0)
        return this._i
    }
    async fetch(fileId:string){
        const file = await FManApi.i.getFile(fileId)
        await Usernames.i.get()
        return file
    }
    async fetchBatch(fileIds:string[]){
        const files = await FManApi.i.getFiles(fileIds)
        const userIds = files.map(file => file.createdBy).filter(uid => !!uid)
        await Usernames.i.get()
        return files
    }
    async deleteFile(files:FMFile[], recursive:boolean){
        if (!files.length) return

        // make sure selected files are from same parent
        const parentId = files[0].parentId
        for(const file of files) {
            if (file.parentId!=parentId) throw {status:400,msg:"Can only delete multiple files from same parent"}
        }

        await FManApi.i.deleteFile(files.map(file => file._id), recursive)
        if (files.find(file => FMFile.isDir(file))) Dirs.i.expire().get()

        for(const file of files) {
            this.remove(file._id)
        }

        if (parentId) {
            const parent = await this.get(parentId)
            for(const file of files) parent.removeChild(file)
            this.add(parent._id, parent)
        }
    }
    async createSession(rootId:string, name:string, size:number, conflictResolution:TConfligResolution){
        const file = await FManApi.i.createSession(rootId, name, size, conflictResolution)
        this.add(file._id, file)
        return file
    }
    async appendFile(fileId:string, offset:number, buffer:Uint8Array){
        const file = await FManApi.i.appendFile(fileId, offset, buffer)
        this.add(file._id, file)
        return file
    }
}